import { Palette, PaletteColor } from '@mui/material';
import { ReactNode } from 'react';
import { styled, Stack, Grid, Box, Card } from '@/theme/index';

export const EmptyLine = styled(Box)(({ theme, color, height }) => {
  const colorObject = theme.palette[color as keyof Palette];
  const colorValue = color
    ? (colorObject as PaletteColor).main
    : theme.palette.grey[200];
  return {
    width: '100%',
    height: 0,
    border: `1px solid ${colorValue}`,
    [theme.breakpoints.up('md')]: {
      height: `${height || '100px'}`,
      width: 0,
    },
  };
});

export const GradientLine = styled(Box)(({ theme }) => ({
  width: '15px',
  height: '100%',
  background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%,  ${theme.palette.grey[50]} 100%)`,
  borderRadius: '10px',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    height: '15px',
    background: `linear-gradient(90deg, ${theme.palette.grey[50]} 0%,  ${theme.palette.primary.dark} 100%)`,
  },
}));

export const GridStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row-reverse',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
  },
}));

export const LineCard = ({
  children,
  marginTop,
  color,
}: {
  children: ReactNode;
  marginTop: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning';
}) => {
  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderColor: color
          ? theme.palette[color].main
          : theme.palette.grey[200],
        [theme.breakpoints.up('md')]: {
          marginTop,
          marginX: 'auto',
          maxWidth: 'fit-content',
          padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        },
      })}
    >
      {children}
    </Card>
  );
};

export const BoxWithLine = ({
  children,
  color,
  height,
}: {
  children: ReactNode;
  color?: string;
  height?: string;
}) => {
  height = height ? '100px' : '40px';
  return (
    <Grid
      container
      gap={0}
      sx={(theme) => ({
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      })}
    >
      <Grid item xs={8} md={12}>
        {children}
      </Grid>
      <Grid
        item
        xs={4}
        md={12}
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          [theme.breakpoints.up('md')]: {
            alignItems: 'flex-end',
            justifyContent: 'center',
          },
        })}
      >
        <EmptyLine color={color} height={height} />
      </Grid>
    </Grid>
  );
};
